import { type FunctionComponent, useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { article as articleData } from "shared/data/article";

import { getArticleType } from "scmp-app/components/article/article-render/helpers";
import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";
import type { featuredOpinionBlockItemContent$key } from "scmp-app/queries/__generated__/featuredOpinionBlockItemContent.graphql";

import { StyledContentItemPlusOpinion, StyledContentItemPlusPrimary } from "./styles";

export type Props = {
  reference: featuredOpinionBlockItemContent$key;
};

export const FeaturedOpinionBlockItem: FunctionComponent<Props> = ({ reference }) => {
  const content = useFragment(
    graphql`
      fragment featuredOpinionBlockItemContent on Content {
        ...hooksPlusArticleLinkHandlerArticle
        ...helpersGetArticleTypeArticle
        ...plusOpinionContentItemContent
        ...plusPrimaryContentItemContent
        ...plusSecondaryContentItemContent
      }
    `,
    reference,
  );

  const { handleOpen } = usePlusArticlePopup();
  const articleTypeId = getArticleType(content) ?? "";

  const isOpinionArticle = useMemo(
    () =>
      articleTypeId === articleData.types.opinion.entityId ||
      articleTypeId === articleData.types.column.entityId,
    [articleTypeId],
  );

  if (isOpinionArticle)
    return (
      <StyledContentItemPlusOpinion
        onClick={() =>
          handleOpen(content, { pageType: "homepage", widgetName: "featured_opinion" })
        }
        reference={content}
        withAuthor
      />
    );

  return (
    <StyledContentItemPlusPrimary
      onClick={() => handleOpen(content, { pageType: "homepage", widgetName: "featured_opinion" })}
      reference={content}
    />
  );
};

FeaturedOpinionBlockItem.displayName = "FeaturedOpinionBlockItem";
